import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// import { Location } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
import { FormGroup, Validators } from '@angular/forms';
import { SalesOrderService } from '../../features/salesOrder/services/salesOrder.service';

@Component({
  selector: 'app-sales-order-details',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    RouterModule,
  ],
  templateUrl: './sales-order-details.component.html',
  styleUrl: './sales-order-details.component.scss',
})
export class SalesOrderDetailsComponent {
  allSalesOrder: any[] = [];
  loading: boolean = false;
  selectedTabIndex = 0; // Default to the first tab
  singleWorkOrder: any;
  detailsLoading: boolean = false;
  private searchSubject = new Subject<string>();
  isAttacheFile = false;
  attachmentType: string | null = null;
  workOrderForm: FormGroup;
  fileDetailsArray: {
    fileName: string;
    fileUrl: string;
    id?: number | null;
    file: any;
  }[] = [];
  // profileName: any;
  salesOrderId: any;
  workOrderData: any = {};
  isLoading: boolean = false;
  constructor(
    private router: Router,
    private salesOrderService: SalesOrderService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    // private location: Location,
    private http: HttpClient
  ) {
    // const loggedInUser: any = localStorage.getItem('loggedInUser');
    // const userData = JSON.parse(loggedInUser);
    // this.profileName = userData?.profileData?.profileName;
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  navigateToPath(route: string) {
    const url = `${route}/${this.singleWorkOrder?.id}`;
    this.router.navigate([url]);
  }

  ngOnInit() {
    this.fetchOrderList();
    this.route.queryParamMap.subscribe((queryParams) => {
      this.salesOrderId = queryParams.get('id');
      if (this.salesOrderId) {
        const id = +this.salesOrderId;
        this.salesOrderService.getSalesOrderById(Number(id)).subscribe({
          next: (data) => {
            this.singleWorkOrder = data;
          },
          error: (error) => {
            if (error?.message === 'No match found') {
              this.navigateTo('/work-order');
            }
          },
        });
      }
      this.searchSubject
        .pipe(debounceTime(600), distinctUntilChanged())
        .subscribe((searchTerm) => {
          this.fetchOrderList(searchTerm);
        });
    });
    console.log(
      'selectedTabIndexselectedTabIndexselectedTabIndex',
      this.selectedTabIndex
    );
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }
  toggleAttachFile(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isAttacheFile = !this.isAttacheFile;
  }
  onSelectType(event: MatSelectChange) {
    this.attachmentType = event.value;
    const fileUrl = this.workOrderForm.get('fileUrl');
    if (event.value == 'DRAWING') {
      console.log(' insde ');

      fileUrl?.setValidators([Validators.required]);
      // fileUrl?.setErrors({ required: true });
    } else {
      fileUrl?.clearValidators();
    }
  }
  handleRemoveFile() {
    this.fileDetailsArray = [];
  }
  openFile(url: any) {
    if (url) {
      window.open(url, '_blank');
    }
  }
  private fetchOrderList(search: string = '') {
    this.salesOrderService.getAllSalesOrders(search).subscribe({
      next: (orders: any) => {
        // Sort the designations by 'id' in descending order so the newest branch comes first
        this.allSalesOrder = orders
          .map((order: any) => order)
          .sort((a: any, b: any) => b.id - a.id);
        if (this.salesOrderId) {
          const targetId = +this.salesOrderId;
          this.selectedTabIndex = this.allSalesOrder.findIndex((c: any) => {
            return c.id === targetId;
          });
          if (this.selectedTabIndex === -1) {
            this.selectedTabIndex = 0;
          }
        } else {
          this.selectedTabIndex = 0;
        }
        this.singleWorkOrder = this.allSalesOrder[this.selectedTabIndex] || {};
      },
      error: (error: any) => {
        this.toastr.error(error, 'Error');
        this.loading = false;
      },
    });
  }

  private loadWorkorder(id: number) {
    // this.detailsLoading = true;
    this.salesOrderService.getWorkOrderById(id).subscribe({
      next: (details) => {
        console.log('workOrderFormworkOrderForm', details);
        try {
          this.singleWorkOrder = details;
          // this.detailsLoading = false;
        } catch (error) {
          // this.detailsLoading = false;
          // this.router.navigate(['/']);
          console.error('Error loading employee data:', error);
        }
      },
      error: (error) => console.error('Error fetching employee types:', error),
    });
  }

  calculateAmount(item: any): number {
    return item?.workOrderSOWs?.length
      ? item?.workOrderSOWs?.reduce(
          (sum: any, item: any) => sum + Number(item.netPrice),
          0
        )
      : 0;
  }

  genPdf(type: boolean) {
    if (this.singleWorkOrder?.id) {
      this.salesOrderService
        .generatePdf(this.singleWorkOrder?.id, type)
        .subscribe({
          next: (details) => {
            this.toastr.success('Successfully Generate PDF');
            this.downloadPDF(details);
          },
          error: (error) =>
            console.error('Error fetching employee types:', error),
        });
    }
  }

  downloadPDF(url: string) {
    const token = localStorage.getItem('AUTH_TOKEN'); // Get token from localStorage
    const fileName = url.substring(url.lastIndexOf('/') + 1);
    const headers = new HttpHeaders({
      Authorization: token ? `Bearer ${token}` : '',
    });
    // Replace with your PDF URL
    this.http.get(url, { headers, responseType: 'blob' }).subscribe(
      (blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = fileName; // Name for the downloaded file
        a.click();
        URL.revokeObjectURL(objectUrl); // Clean up after download
      },
      (error) => {
        console.error('Error downloading PDF', error);
      }
    );
  }
  // selectTab(index: number) {
  //   this.selectedTabIndex = index;
  // }

  selectTab(index: number) {
    // if (this.selectedTabIndex !== index) {
    //   this.selectedTabIndex = index;
    //   this.location.replaceState(`work-order/work-order-details/${index}`);
    //   this.loadWorkorder(+index);
    // }

    this.selectedTabIndex = index;
    if (this.selectedTabIndex) {
      this.router.navigate(['sales-order/sales-order-details'], {
        queryParams: { id: this.selectedTabIndex},
      });
    }
  }
  navigateToSendMail() {
    if (this.singleWorkOrder?.id) {
      this.isLoading = true;
      this.salesOrderService
        .generatePdf(this.singleWorkOrder?.id, true)
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            this.router.navigate([`work-order/send-mail`], {
              queryParams: {
                salesOrderId: this.singleWorkOrder.id,
                pdfResponse: encodeURIComponent(JSON.stringify(response)),
              },
            });
          },
          error: (error) => {
            this.isLoading = false;
            // this.toastr.error('Failed to generate PDF. Please try again.', 'Error');
          },
        });
    } else {
      this.toastr.warning('No Work Order selected', 'Warning');
    }
  }

  readonly dialog = inject(MatDialog);

  openDialog() {
    const dialogRef = this.dialog.open(UploadworkDetailsDialog);
  }

  isDropdownOpen = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}

@Component({
  selector: 'upload-work-details-dialog',
  templateUrl: 'upload-sales-details-dialog.html',
  styleUrls: ['./sales-order-details.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class UploadworkDetailsDialog {
  file: any = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('Selected file:', file);
      this.file = file;
    }
  }
}
